// Field-level "force a value based on who is submitting" rules.
//
// This is the FRONTEND half of an admin-configured feature (formGroupConfig →
// field.autoValueRules), e.g. a submission's "Submit Source" that must read
// External when an employer-type user submits and Internal for everyone else.
//
// It mirrors the backend exactly (models.AutoValueRule.Matches +
// applyAutoValueRules in moduleWriteOrchestrator.go). The backend is the
// authority — it re-evaluates these rules from the auth token on every
// create/update, so a request that bypasses the UI is still corrected. This copy
// exists purely so the user SEES the forced value while filling the form.
//
// Nothing here special-cases a module, field, role or value: which roleId/userId
// maps to which value is entirely admin data.

// autoValueFor evaluates a field's rules against the acting user's identity
// ({roleId, userId}). whenRoleId and whenUserId are OR-ed; a rule with neither
// set never fires. First matching rule wins — same as the backend.
export function autoValueFor(field, identity = {}) {
  const rules = Array.isArray(field?.autoValueRules) ? field.autoValueRules : [];
  for (const rule of rules) {
    const roles = Array.isArray(rule?.whenRoleId) ? rule.whenRoleId.map(Number) : [];
    const users = Array.isArray(rule?.whenUserId) ? rule.whenUserId.map(Number) : [];
    const roleHit = identity.roleId !== undefined && roles.includes(identity.roleId);
    const userHit = identity.userId !== undefined && users.includes(identity.userId);
    if (roleHit || userHit) return { matched: true, value: rule.value };
  }
  return { matched: false, value: undefined };
}

export default autoValueFor;
